import { api, ApiRequestConfig } from '../../api';

type TFetchModel = {
	pathname: string;
	region: string;
};

export const fetchPageModel = (url: string, params: TFetchModel, config?: ApiRequestConfig) =>
	api.get(url, params, config);
